import { Ref } from "react";
import { Trans } from "react-i18next";
import { ConsentRow } from "./Styles";

export const TERMS_URL = "https://virtualmike.ai/terms-and-conditions";
const PRIVACY_URL = "https://www.virtualmike.net/privacy-policy";

interface TermsConsentProps {
  checked: boolean;
  onChange: (checked: boolean) => void;
  disabled?: boolean;
  inputRef?: Ref<HTMLInputElement>;
}

/**
 * The checkbox to accept the terms and conditions and the privacy policy, both linked in a new tab.
 * Nothing is stored: whoever renders it just doesn't let go on until it is checked.
 * @param checked - Whether the user accepted.
 * @param onChange - Called with the new value when the user toggles it.
 * @param disabled - Locks the checkbox, e.g. while the case is being created.
 * @param inputRef - The checkbox itself, to take the user to it when left unchecked.
 */
export const TermsConsent = ({ checked, onChange, disabled, inputRef }: TermsConsentProps) => (
  <ConsentRow>
    <input
      ref={inputRef}
      type="checkbox"
      checked={checked}
      disabled={disabled}
      onChange={(e) => onChange(e.target.checked)}
    />
    <span>
      <Trans
        i18nKey="common.termsConsent.label"
        components={{
          1: <a href={TERMS_URL} target="_blank" rel="noopener noreferrer" />,
          3: <a href={PRIVACY_URL} target="_blank" rel="noopener noreferrer" />,
        }}
      />
    </span>
  </ConsentRow>
);
